/**
 * Tour 1: Canvas Basics — "Build your first topology in 60 seconds"
 */

const TOUR_ID = "canvas-basics";

/** @param {{ t: (key: string, opts?: object) => string }} deps */
export function getCanvasBasicsSteps({ t }) {
  return {
    id: TOUR_ID,
    label: t("Canvas Basics", { defaultValue: "Canvas Basics" }),
    description: t("Build your first topology in 60 seconds", {
      defaultValue: "Build your first topology in 60 seconds",
    }),
    steps: [
      {
        element: '[data-tour="device-palette"]',
        popover: {
          title: t("Device Library", { defaultValue: "Device Library" }),
          description: t(
            "This is your device library. Browse categories and drag any device onto the canvas to place it.",
            {
              defaultValue:
                "This is your device library. Browse categories and drag any device onto the canvas to place it.",
            },
          ),
          side: "left",
          align: "start",
        },
      },
      {
        element: '[data-tour="device-palette-item"]',
        popover: {
          title: t("Drag a Device", { defaultValue: "Drag a Device" }),
          description: t(
            "Grab any device card and drag it onto the canvas. Try a router or a switch to start.",
            {
              defaultValue:
                "Grab any device card and drag it onto the canvas. Try a router or a switch to start.",
            },
          ),
          side: "left",
          align: "start",
        },
      },
      {
        element: '[data-tour="topology-canvas"]',
        popover: {
          title: t("Your Canvas", { defaultValue: "Your Canvas" }),
          description: t(
            "This is your topology canvas. Drop devices here to place them. The dotted grid helps you align things visually.",
            {
              defaultValue:
                "This is your topology canvas. Drop devices here to place them. The dotted grid helps you align things visually.",
            },
          ),
          side: "left",
          align: "center",
        },
      },
      {
        element: '[data-tour="canvas-controls-zoom"]',
        popover: {
          title: t("Zoom Controls", { defaultValue: "Zoom Controls" }),
          description: t(
            "Zoom in/out or fit the entire topology in view. You can also scroll to zoom and drag to pan.",
            {
              defaultValue:
                "Zoom in/out or fit the entire topology in view. You can also scroll to zoom and drag to pan.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
      {
        element: '[data-tour="canvas-minimap"]',
        popover: {
          title: t("Mini Map", { defaultValue: "Mini Map" }),
          description: t(
            "Use the mini-map to navigate large topologies. Click anywhere on it to jump to that area.",
            {
              defaultValue:
                "Use the mini-map to navigate large topologies. Click anywhere on it to jump to that area.",
            },
          ),
          side: "left",
          align: "end",
        },
      },
      {
        element: '[data-tour="canvas-search"]',
        popover: {
          title: t("Search Devices", { defaultValue: "Search Devices" }),
          description: t(
            "Find any device by name, IP, or hostname. Press Ctrl+F to open search anytime.",
            {
              defaultValue:
                "Find any device by name, IP, or hostname. Press Ctrl+F to open search anytime.",
            },
          ),
          side: "bottom",
          align: "end",
        },
      },
      {
        element: '[data-tour="canvas-expand"]',
        popover: {
          title: t("Expand Canvas", { defaultValue: "Expand Canvas" }),
          description: t(
            "Need more space? Expand the canvas to full screen for detailed work.",
            {
              defaultValue:
                "Need more space? Expand the canvas to full screen for detailed work.",
            },
          ),
          side: "right",
          align: "center",
        },
      },
    ],
  };
}

export default getCanvasBasicsSteps;
